import * as React from "react"

function SvgLoading(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.332 11.531A5.948 5.948 0 016 12a5.948 5.948 0 01-4.242-1.758A5.976 5.976 0 010 6c0-.117.04-.215.117-.293a.417.417 0 01.305-.129.38.38 0 01.293.129A.38.38 0 01.844 6c0 .703.136 1.371.41 2.004a5.055 5.055 0 001.101 1.64 5.216 5.216 0 001.641 1.114c.633.265 1.3.398 2.004.398a5 5 0 002.004-.41 5.055 5.055 0 001.64-1.101 5.216 5.216 0 001.114-1.641c.265-.633.398-1.3.398-2.004a5 5 0 00-.41-2.004 5.055 5.055 0 00-1.101-1.64 5.216 5.216 0 00-1.641-1.114A5.125 5.125 0 006 .844a.438.438 0 01-.305-.117.438.438 0 01-.117-.305c0-.117.04-.215.117-.293A.417.417 0 016 0a5.95 5.95 0 014.242 1.758A5.974 5.974 0 0112 6a5.948 5.948 0 01-1.758 4.242 5.975 5.975 0 01-1.91 1.29z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgLoading
